import React, { useMemo } from 'react';
import {
  BodyTextRegularB,
  BodyTextMediumA,
  HeadingBoldH5,
} from '@/shared/ui/typography2';
import { BoxCondition, ConditionItem } from './styles';
import { WrapperOptions } from '../options-block/styles';
import type { Translate } from '@locales/client';

export const CONDITION_MAP_KEYS = {
  wager: 'card.wager',
  maxDeposit: 'card.max_deposit',
  minDeposit: 'card.min_deposit',
  maxWin: 'card.max_win',
  maxBet: 'card.max_bet',
  percent: 'card.percent',
  spins: 'card.spins',
  bonusSum: 'card.amount',
  bet: 'card.bet',
};

export interface BonusOptionCondition {
  label: string;
  value: string | number;
}

interface ConditionBlockProps {
  options?: { conditions?: BonusOptionCondition[] }[];
  conditionActive: number | null;
  t: Translate;
}

export const ConditionBlock = React.memo(
  ({ options, conditionActive, t }: ConditionBlockProps) => {
    const conditions = useMemo(() => {
      if (!options?.length) return [];

      const targetOption =
        (conditionActive === null ? undefined : options[conditionActive]) ??
        options[0];
      return targetOption?.conditions || [];
    }, [options, conditionActive]);

    const conditionMap = useMemo(
      () =>
        Object.entries(CONDITION_MAP_KEYS).reduce<Record<string, string>>(
          (acc, [key, translationKey]) => {
            acc[key] = t(translationKey);
            return acc;
          },
          {}
        ),
      [t]
    );

    if (!conditions.length) return null;

    return (
      <>
        <HeadingBoldH5>{t('card.terms')}</HeadingBoldH5>
        <WrapperOptions>
          {conditions.map(({ label, value }) => (
            <ConditionItem key={label}>
              <BoxCondition>
                <BodyTextRegularB color="#AFAFAF">
                  {conditionMap[label] || label}
                </BodyTextRegularB>
                <BodyTextMediumA>{value}</BodyTextMediumA>
              </BoxCondition>
            </ConditionItem>
          ))}
        </WrapperOptions>
      </>
    );
  }
);
